export default __webpack_public_path__ + "static/media/rails.098cc1b5.png";